import { useState } from 'react';
import { Loader2, Plus } from 'lucide-react';

export const QuoteAddAllPanel = ({ count, label, busy, onConfirm, onCancel }) => {
  const [qty, setQty] = useState(1);
  const valid = parseInt(qty, 10) >= 1;
  return (
    <div className="border border-neutral-900 bg-neutral-50 p-3 mt-2 flex flex-wrap items-end gap-3" data-testid="quote-add-all-panel">
      <div className="flex-1 min-w-[180px]">
        <p className="serif text-sm">Add all {count} product{count === 1 ? '' : 's'}{label ? ` from ${label}` : ''}</p>
        <p className="sans text-[11px] text-neutral-500 mt-0.5">Items already in the quote are skipped.</p>
      </div>
      <div>
        <label className="sans text-[9px] tracking-widest uppercase text-neutral-500 block mb-1">Qty each</label>
        <input type="number" min={1} value={qty} onChange={(e) => setQty(e.target.value)} className="ije-input h-9 w-20 text-sm" data-testid="quote-add-all-qty" />
      </div>
      <button type="button" onClick={onCancel} className="sans text-[11px] tracking-widest uppercase text-neutral-500 hover:text-black h-9 px-2" data-testid="quote-add-all-cancel">Cancel</button>
      <button type="button" disabled={!valid || busy} onClick={() => onConfirm(parseInt(qty, 10))} className="btn-primary h-9 disabled:opacity-40" data-testid="quote-add-all-confirm">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />} Add all
      </button>
    </div>
  );
};
